import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, index }) {
  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block bg-white border border-[#E2E8F0] hover:border-[#0EA5E9] transition-colors"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F1F5F9]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="zoom-img absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute top-3 left-3 bg-[#0A192F] text-white text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-1">
          {String(index + 1).padStart(2, "0")}
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-head font-bold text-[#0A192F] text-lg leading-snug">
          {product.name}
        </h3>
        <p className="mt-2 text-sm text-[#475569] line-clamp-2 leading-relaxed">
          {product.short}
        </p>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex flex-wrap gap-1.5">
            {product.tags.slice(0, 2).map((t) => (
              <span
                key={t}
                className="text-[10px] uppercase tracking-wider bg-[#F1F5F9] text-[#475569] px-2 py-1"
              >
                {t}
              </span>
            ))}
          </div>
          <span className="flex items-center gap-1 text-xs font-bold uppercase tracking-[0.18em] text-[#0EA5E9] group-hover:gap-2 transition-all">
            View
            <ArrowUpRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  );
}
